import { useHandbook } from 'components/Handbook2_0/hooks'
import { useUserRole } from './useUserRole'
import { UserRole } from 'types'

export const useGuestVisitingHandbook = () => {
  const role = useUserRole()
  const handbookV2 = useHandbook()
  return role === UserRole.UNAUTHED && handbookV2 != null
}
